import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/home/hero/Hero';
import { References } from '../components/home/references/References';
import { Universes } from '../components/home/universes/Universes';
import { Workshop } from '../components/home/workshop/Workshop';
import { CaseTeaser } from '../components/home/case/CaseTeaser';
import { ContactSection } from '../components/home/contact/ContactSection';
export function Home() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = window.setTimeout(() => document.querySelector(hash)?.scrollIntoView({
      behavior: 'smooth'
    }), 80);
    return () => window.clearTimeout(t);
  }, [hash]);
  return <main data-id="element-366" data-mp="2dj1n0uuvbj90">
      <Hero data-id="element-367" data-mp="2dfm7jqxa8872" />
      <References data-id="element-368" data-mp="3kvadcpw1yhx4" />
      <Universes data-id="element-369" data-mp="3kvtnhkfgo20l" />
      <Workshop data-id="element-370" data-mp="3ku8sjtp8ih27" />
      <CaseTeaser data-id="element-371" data-mp="3kuqu95uo1nhi" />
      <ContactSection data-id="element-372" data-mp="3kxd1f4dna0z7" />
    </main>;
}